import Forum from "messaging/entities/forum/forum";
import SubscriberAPIRequest from "messaging/values/subcriber/api/request-contracts/subscriber-api-request";

export default class ForumAPIRequest {
  id?: string;
  name?: string;
  entityClass?: string;
  entityId?: string;
  context?: string;
  subscribers: SubscriberAPIRequest[];

  constructor(forum: Forum) {
    if (!forum) throw new Error("Forum must be defined");
    this.id = forum.id?.toString();
    this.name = forum.name?.toString();
    this.entityClass = forum.topic?.entityClass?.toString();
    this.entityId = forum.topic?.entityId?.toString();
    this.context = forum.topic?.context?.toString();
    this.subscribers = forum.subscribers ?
      forum.subscribers.map((s) => new SubscriberAPIRequest(s)) :
      [];
  }
}
